import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {createWord, changeField, searchScenario, initializeSearchResult, validateWord, initializeValidationResult} from '../../../modules/admin/voca';
import useDebounce from '../../../hooks/useDebounce';
import validateInput from '../../../utils/validateInput';
import {IoIosClose} from 'react-icons/io';
import {IoSearch} from 'react-icons/io5';
import {ReactComponent as LockIcon} from '../../../assets/scenario/lock.svg';
import {ReactComponent as UnLockIcon} from '../../../assets/scenario/unlock.svg';
import styles from './styles/vocaModal.module.css';

export default function VocaCreateModal({ setIsOpenModal, wordList, category }) {
    const dispatch = useDispatch();

    const {createResponse, createErrorResponse, searchScenarioResponse, searchScenarioErrorResponse} = useSelector(({voca}) => ({
        createResponse: voca.createResponse,
        createErrorResponse: voca.createErrorResponse,
        searchScenarioResponse: voca.searchScenarioResponse,
        searchScenarioErrorResponse: voca.searchScenarioErrorResponse
    }));

    const [userConfirm, setUserConfirm] = useState(false);
    const [standardWord, setStandardWord] = useState('');
    const [useWord, setUseWord] = useState('');
    const [useWordList, setUseWordList] = useState([]);
    const [error, setError] = useState('');
    const [errorStd, setErrorStd] = useState('');
    const [createError, setCreateError] = useState('');
    const [spreadWordList, setSpreadWordList] = useState([]);
    const ERROR_MESSAGE_USE_WORD = '중복되는 단어가 있습니다.';
    const ERROR_MESSAGE_STANDARD_WORD = '중복되는 단어가 있습니다.';
    const ERROR_MESSAGE_GENERAL = '중복된 표준 단어 또는 사용 단어가 있습니다.';
    const ERROR_MESSAGE_USE_WORD_EMPTY = '사용 단어를 하나 이상 입력해 주세요.';
    const ERROR_MESSAGE_ALERT_DANGER = '입력 값에 허용되지 않는 특수문자 또는 위험한 코드가 포함되어 있습니다.';
    const ERROR_MESSAGE_DANGER_INPUT = '유효한 단어를 입력해 주세요';
    const ERROR_MESSAGE_SERVER_ERROR = '서버 오류로 등록에 실패했어요.';
    const ENGLISH = 0;
    const KOREAN = 1;

    const [scenarioNameToSearch, setScenarioNameToSearch] = useState('');
    const debouncedScenarioName = useDebounce(scenarioNameToSearch, 1000);
    const [isShownSearchResult, setIsShownSearchResult] = useState(false);
    const [scenarioStandardWordList, setScenarioStandardWordList] = useState([]);
    const [scenarioNameDropDown, setScenarioNameDropDown] = useState([]);

    const handleAddUseWord = (e) => {
        const inputWord = useWord.trim();
        if (e.key === 'Enter' && inputWord !== '') {
            const koreanIncluded = /[가-힣]/.test(inputWord);
            processAddUseWord(inputWord, koreanIncluded ? KOREAN : ENGLISH);
        }
    };

    const handleDeleteWord = (index) => {
        const updatedList = useWordList.filter((_, i) => i !== index);
        setUseWordList(updatedList);

        if (!updatedList.includes(useWord)) {
            setError('');
        }
    };

    const handleDeleteScenarioWord = (index) => {
        if (isShownSearchResult) setIsShownSearchResult(false);
        const updatedList = scenarioStandardWordList.filter((_, i) => i !== index);
        setScenarioStandardWordList(updatedList);

        if (!updatedList.includes(scenarioNameToSearch)) {
            setError('');
        }
    };

    const handleCreateWord = () => {
        if (useWordList.length === 0) {
            alert(ERROR_MESSAGE_USE_WORD_EMPTY);
            return;
        }
        if (error || errorStd) {
            alert(ERROR_MESSAGE_GENERAL);
            return;
        }
        setUserConfirm(true);
        if (category === 'WORD') {
            dispatch(createWord({ category: category, standardWord, useWordList: useWordList.map(word => word.toUpperCase()) }));
        } else {
            dispatch(createWord({ category: category, standardWord: scenarioStandardWordList.map(x => x.id), useWordList: useWordList.map(word => word.toUpperCase()) }));
        }
    };

    const validateStandardWord = async (value) => {
        const inputWord = value.trim();
        try {
            // { isValid, invalidTarget }
            const result = await new Promise((resolve, reject) => {
                dispatch(validateWord({ category: 'WORD', target: 'STANDARD', value: inputWord, resolve, reject }))
            });
            if (!result) {
                setErrorStd(ERROR_MESSAGE_SERVER_ERROR);
                return;
            }
            
            if (result.isValid === true) {
                setErrorStd('');
            } else {
                setErrorStd(ERROR_MESSAGE_STANDARD_WORD);
            }
        } catch (e) {
            console.error(e);
            setErrorStd(ERROR_MESSAGE_SERVER_ERROR);
        }
        //const koreanIncluded = /[가-힣]/.test(inputWord);
        //processEnterStandardWord(inputWord, koreanIncluded ? KOREAN : ENGLISH);
    };

    const handleChangeStandardWord = (value) => {
        setStandardWord(value);
    };

    const handleOnBlurStandardWord = (e) => {
        if (standardWord == '') {
            setErrorStd('');
            return;
        }
        validateStandardWord(standardWord);
    };

    const handleChangeScenarioName = (value) => {
        setScenarioNameToSearch(value);
    };
    const handleOnBlurScenarioName = (e) => {
        if (scenarioNameToSearch.trim().length < 1) {
            setIsShownSearchResult(false);
        }
    };

    const validateDuplicatedLocalUseWord = (inputWord, culture) => {
        if (culture === ENGLISH) {
            if (useWordList.some(word => word.toUpperCase() === inputWord.toUpperCase())) return true;
        } else {
            if (useWordList.includes(inputWord)) return true;
        }
        return false;
    };

    const processAddUseWord = async (inputWord, culture) => {
        if (!validateInput(inputWord)) {
            alert(ERROR_MESSAGE_ALERT_DANGER);
            setUseWordList([...useWordList, inputWord]);
            setError(ERROR_MESSAGE_DANGER_INPUT);
            return;
        }

        if (validateDuplicatedLocalUseWord(inputWord, culture)) {
            setUseWordList([...useWordList, inputWord]);
            setError(ERROR_MESSAGE_USE_WORD);
            setUseWord('');
            return;
        }

        try {
            const result = await new Promise((resolve, reject) => {
                dispatch(validateWord({ category, target: 'USE', value: inputWord, resolve, reject }))
            });
            if (!result) {
                setUseWordList([...useWordList, inputWord]);
                setError(ERROR_MESSAGE_SERVER_ERROR);
                return;
            }
            
            if (result.isValid === true) {
                setUseWordList([...useWordList, inputWord]);
                setError('');
            } else {
                if (result.invalidTarget) {
                    setUseWordList([...useWordList, inputWord]);
                    setError(result.invalidTarget.target === 'USE' ? ERROR_MESSAGE_USE_WORD : ERROR_MESSAGE_STANDARD_WORD);
                } else {
                    setUseWordList([...useWordList, inputWord]);
                    setError(ERROR_MESSAGE_USE_WORD);
                }
            }
        } catch (e) {
            console.error(e);
            setUseWordList([...useWordList, inputWord]);
            setError(ERROR_MESSAGE_SERVER_ERROR);
        }
        setUseWord('');
    };

    const handleSelectScenario = (scenario) => {
        setIsShownSearchResult(false);
        dispatch(initializeSearchResult());
        if (scenario && scenario.id) {
            const idList = scenarioStandardWordList.map(x => x.id);
            if (!idList.includes(scenario.id)) {
                setScenarioStandardWordList(prev => ([...prev, scenario]));
                setErrorStd('');
                setScenarioNameToSearch('');
            }
        }
    };

    const handleOnKeyUpScenarioName = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            if (scenarioNameToSearch.trim().length < 1) {
                setIsShownSearchResult(false);
            } else {
                if (scenarioNameDropDown.length > 0) {
                    setScenarioNameDropDown(prev => prev.filter(scenario => !scenarioStandardWordList.some(added => scenario.id === added.id)));
                    setIsShownSearchResult(true);
                }
            }
        }
    };

    useEffect(() => {
        if (!wordList) return;

        const spreadWords = [];
        wordList.forEach((word) => {
            spreadWords.push({
                standardWord: word.standardWord,
                useWordList: word.useWordList
            });
        });
        setSpreadWordList(spreadWords);
    }, [wordList]);

    useEffect(() => {
        if (userConfirm && createResponse) {
            setIsOpenModal(false);
        }

        if (createErrorResponse) {
            setCreateError(ERROR_MESSAGE_GENERAL);
        }
    }, [createResponse, createErrorResponse]);

    useEffect(() => {
        if (debouncedScenarioName) {
            dispatch(searchScenario({name: debouncedScenarioName.trim()}));
        }
    }, [dispatch, debouncedScenarioName]);

    useEffect(() => {
        if (searchScenarioResponse) {
            const filtered = searchScenarioResponse.filter(scenario => !scenarioStandardWordList.some(added => scenario.id === added.id));
            setScenarioNameDropDown([...filtered]);
            setIsShownSearchResult(true);
        }
    }, [searchScenarioResponse]);

    useEffect(() => {
        dispatch(changeField({
            name: 'createErrorResponse',
            value: null
        }));
        dispatch(changeField({
            name: 'createResponse',
            value: null
        }));
    }, []);

    return (
        <div>
            <div className={styles.containerModal}>
                <h1>{category === 'WORD' ? '용어' : '시나리오 단어'} 등록</h1>
                <button className={styles.btnCreate} onClick={handleCreateWord} disabled={error || errorStd || (!standardWord && (!scenarioStandardWordList || scenarioStandardWordList.length < 1)) || useWordList.length < 1}>저장하기</button>
            </div>
            <div>
                {createErrorResponse && <p style={{color: 'red', fontSize: '10px'}}>{createError}</p>}
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>
                    <p className={styles.tileText}>{category === 'WORD' ? '표준 단어' : '시나리오'}</p>
                    {errorStd && <p style={{color: 'red', fontSize: '10px', textAlign: 'center'}}>{errorStd}</p>}
                </div>
                {category === 'SCENARIO' &&
                    <div className={styles.useWordTd} style={{marginBottom: '10px', overflowY: 'auto' ,maxHeight: '240px'}}>
                        {scenarioStandardWordList.map((voca, index) => (
                            <div key={index} className={styles.useWordCont} style={{width: 'fit-content'}}>
                                <div className={styles.useWordGroup}>
                                <p className={styles.useWordP}>
                                    {voca.name}{voca.isPublic ? <UnLockIcon style={{maxHeight: '11px', margin: '0 0 -1px 4px'}}/> : <LockIcon style={{maxHeight: '11px', margin: '0 0 -1px 4px'}}/>}
                                </p>
                                <button onClick={() => handleDeleteScenarioWord(index)} className={styles.closeButton}>
                                    <IoIosClose className={styles.closeIcon} />
                                </button>
                                </div>
                            </div>
                        ))}
                    </div>
                }
                {category === 'WORD'
                    ? <input className={styles.Input} style={errorStd ? {color: 'red'} : {}}
                        placeholder='표준 단어를 입력하세요'
                        value={standardWord}
                        onChange={(e) => handleChangeStandardWord(e.target.value)}
                        onBlur={(e) => handleOnBlurStandardWord(e)}
                        autoComplete='off'
                    />
                    : <div className={styles.box}>
                        <div className={styles.scenarioInputDiv}>
                            <input className={styles.scenarioInput}
                                    placeholder='시나리오를 입력하세요'
                                    value={scenarioNameToSearch}
                                    onChange={(e) => handleChangeScenarioName(e.target.value)}
                                    onBlur={(e) => handleOnBlurScenarioName(e)}
                                    onKeyUp={handleOnKeyUpScenarioName}
                                    autoComplete='off'
                            />
                            <IoSearch className={styles.iconSearch}/>
                        </div>
                        {isShownSearchResult && scenarioNameDropDown.length > 0 && 
                            <ul datatype='searchText'>
                            {scenarioNameDropDown.map((search, index) => (
                                <li key={index}
                                    onClick={() => {
                                        handleSelectScenario(search);
                                    }}
                                >
                                    {search.name}{search.isPublic ? <UnLockIcon style={{maxHeight: '14px', margin: '0 0 -1px 8px'}}/> : <LockIcon style={{maxHeight: '14px', margin: '0 0 -1px 8px'}}/>}
                                </li>
                            ))}
                            </ul>
                        }
                    </div>
                }
            </div>
            <div className={styles.useWordDiv}>
                <p className={styles.tileText}>{category === 'WORD' ? '사용 단어' : '시작 단어'}</p>
                <div className={styles.useWordTd} style={category === 'SCENARIO' ? { overflowY: 'auto' ,maxHeight: '240px' } : {}}>
                    {useWordList.map((voca, index) => (
                        <div key={index} className={styles.useWordCont}>
                            <div className={styles.useWordGroup}>
                            <p className={styles.useWordP} style={error && index === (useWordList.length - 1) ? {color: 'red'} : {}}>{voca}</p>
                            <button onClick={() => handleDeleteWord(index)} className={styles.closeButton}>
                                 <IoIosClose className={styles.closeIcon} />
                            </button>
                            </div>
                        </div>
                    ))}
                    {error && <p style={{color: 'red', fontSize: '12px', fontWeight: '500'}}>{error}</p>}
                    {!error &&
                        <input className={styles.editInput}
                               placeholder='단어를 입력하세요'
                               value={useWord}
                               onChange={(e) => setUseWord(e.target.value)}
                               onKeyUp={handleAddUseWord}
                               autoComplete='off'
                        />
                    }
                </div>
            </div>
        </div>
    );
}
